import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';

import Axios from '@/lib/axios-instance';

type APIPayload = {
  website_type: string;
  website_url: string;
  shopify_access_token?: string;
  shopify_api_secret?: string;
  shopify_api_key?: string;
  mode?: string;
  locator?: string;
};

export const createWebSettings = async (payload: APIPayload) => {
  try {
    const response = await Axios.post('/web_settings', payload);
    return response.data;
  } catch (error: any) {
    throw error?.response?.data;
  }
};

export const useCreateWebSettings = () => {
  return useMutation({
    mutationFn: (payload: APIPayload) => createWebSettings(payload),
    onSuccess: (data) => {
      toast.success('Web settings created successfully');
      console.log({ data });
    },
    onError: (error) => {
      toast.error('Unable to create web settings.', {
        description: error.message,
      });
      console.log({ error });
    },
  });
};
